import { Component, Input, OnInit } from '@angular/core';
import { ModulesManagerService } from '../../../classes/Module/modules-manager.service';
import { UserContact } from 'src/app/classes/Contact/user-contact';


@Component({
    selector: 'app-contact-selector',
    templateUrl: './contact-selector.page.html',
    styleUrls: ['./contact-selector.page.scss'],
    standalone: false
})
export class ContactSelectorPage implements OnInit {
  public filterContact = "";
  @Input() contacts: Array<any> = []
  @Input() callBack: any = null;

  constructor(public manager: ModulesManagerService) { }

  ngOnInit() {
  }

  get Contacts() {
    return this.contacts.filter((contact: UserContact) => contact.inFilter(this.filterContact))
      .sort((a, b) => b.IsDefault - a.IsDefault)
  }

  public onSelect(contact) {
    this.filterContact = ""
    this.callBack(contact)
    this.manager.closeModal()
  }

}
